import { commonServerInstance, downloadInstance } from '@/utilities/instances'
import { downloadFile } from './common'

export const searchInvoiceList = async (params: any) => {
  const response = await commonServerInstance.post('/settlement/invoicelist', {
    ...params
  })
  return response.data.data
}

export const getInvoiceDetails = async (params: any) => {
  const response = await commonServerInstance.post('/settlement/invoice', {
    ...params
  })
  return response.data.data
}

export const downloadInvoiceFiles = async (params: any) => {
  const response = await downloadInstance.post(
    '/settlement/downloadinvoicefiles',
    {
      ...params
    }
  )
  return await downloadFile(response, params.file_name)
}

export const downloadCreditMemoTemplate = async () => {
  const response = await downloadInstance.post('/settlement/downloadtemplate', {
    type: 'Credit Memo'
  })
  return await downloadFile(response, 'template.xlsx')
}

export const uploadCreditMemoFile = async (formData: any) => {
  const response = await commonServerInstance.post(
    '/settlement/uploadcreditmemo',
    formData
  )
  return response.data.data
}
